import React from 'react';

import { defineMessages, useIntl } from 'react-intl';
import styled from 'styled-components';

import ActionButton from 'components/action-button';
import Link from 'components/link';
import { ModalContent, ModalHeading } from 'components/modal';
import { ServiceMode } from 'state/order';
import { routes } from 'utils/routing';

import { IServiceModeCatering } from './types';

const ActionButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  :first-of-type button {
    margin-bottom: 1rem;
  }
`;

const LinkWrapper = styled.div`
  text-align: center;
`;

const ServiceModeCatering: React.FC<IServiceModeCatering> = ({
  enableDelivery,
  selectServiceMode,
  handleCancel,
}) => {
  const { formatMessage } = useIntl();

  return (
    <ModalContent>
      <ModalHeading id="modal-heading">{formatMessage(messages.serviceModePrompt)}</ModalHeading>
      <ActionButtonContainer>
        <ActionButton
          disabled={!enableDelivery}
          data-testid="service-mode-delivery"
          onClick={() => selectServiceMode(ServiceMode.CATERING_DELIVERY)}
        >
          {enableDelivery
            ? formatMessage(messages.delivery)
            : formatMessage(messages.deliveryUnavailable)}
        </ActionButton>
        <ActionButton
          data-testid="service-mode-pickup"
          onClick={() => selectServiceMode(ServiceMode.CATERING_PICKUP)}
        >
          {formatMessage(messages.pickUp)}
        </ActionButton>

        <LinkWrapper>
          <Link to={routes.base} onClick={handleCancel}>
            {formatMessage(messages.cancelCateringOrder)}
          </Link>
        </LinkWrapper>
      </ActionButtonContainer>
    </ModalContent>
  );
};

export default ServiceModeCatering;
const messages = defineMessages({
  cancelCateringOrder: {
    id: 'cancelCateringOrder',
    defaultMessage: 'Cancel Catering Order',
    description: 'No description',
  },

  pickUp: {
    id: 'pickUp',
    defaultMessage: 'Pick Up',
    description: 'No description',
  },

  deliveryUnavailable: {
    id: 'deliveryUnavailable',
    defaultMessage: 'Delivery - Unavailable',
    description: 'Delivery is currently unavailable',
  },

  delivery: {
    id: 'delivery',
    defaultMessage: 'Delivery',
    description: 'No description',
  },

  serviceModePrompt: {
    id: 'serviceModePrompt',
    defaultMessage: 'How would you like to get your food?',
    description: 'No description',
  },
});
